// extracted by mini-css-extract-plugin
export default {"oldSite":"OldSite_oldSite__ofAXS"};